import UsersDropdown from 'components/UsersDropdown';
import React, { useState } from 'react';
import { USER_ROLES } from 'utils';
import styles from './index.module.scss';

const SalesPersonModal = props => {
  const {
    toggleModal,
    title = '',
    onSubmit,
    selectedUser: { objectId: selectedSalesPersonIdFromProps = '' } = {},
  } = props;
  
  const [selectedSalesPersonId, setSelectedSalesPersonId] = useState(selectedSalesPersonIdFromProps);
  const [loading, setLoading] = useState(false);

  const onClickSubmit = async() => {
    try {
      setLoading(true);
      await onSubmit({ userId: selectedSalesPersonId });
      toggleModal();
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }; 
  return (
    <form onSubmit={e => e.preventDefault()} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Sales Person</div>
            <div className={styles['modal-title']}>{title}</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <UsersDropdown value={selectedSalesPersonId} onChange={setSelectedSalesPersonId} role={USER_ROLES.SALES_PERSON} />
        </div>
        <div className={styles['modal-footer']}>
          <button
            type={'button'}
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'button'}
            className={styles['submit-button']}
            disabled={!selectedSalesPersonId || loading}
            onClick={onClickSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default SalesPersonModal;